import { ClipboardCheck } from 'lucide-react';
import { useTeamRequestsManager } from '@/hooks/use-dashboard';
import { WidgetCard } from '../widget-card';
import { Chip } from '../chip';
import { TeamRequestsList } from './team-requests-list';

/**
 * `teamRequestsManager` widget — pending absence requests from the manager's
 * direct reports, approved/rejected inline.
 */
export function TeamRequestsManagerWidget() {
  const { data, isLoading, isError } = useTeamRequestsManager();
  const count = data?.length ?? 0;
  return (
    <WidgetCard
      title="Team Requests Awaiting You"
      icon={ClipboardCheck}
      action={
        !isLoading && !isError && count > 0 ? <Chip color="gray">{count} pending</Chip> : undefined
      }
    >
      <TeamRequestsList data={data} isLoading={isLoading} isError={isError} />
    </WidgetCard>
  );
}
